"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZoomGrids = void 0;
const grid_js_1 = require("@ngageoint/grid-js");
/**
 * Zoom Level Matching Grids
 */
class ZoomGrids extends grid_js_1.BaseZoomGrids {
    /**
     * Constructor
     *
     * @param zoom
     *            zoom level
     */
    constructor(zoom) {
        super(zoom);
    }
    /**
     * Get the grid type precision
     *
     * @return grid type precision
     */
    getPrecision() {
        let type;
        if (super.hasGrids()) {
            type = this.grids.begin().value.getType();
        }
        return type;
    }
}
exports.ZoomGrids = ZoomGrids;
//# sourceMappingURL=ZoomGrids.js.map